import refs from '../helpers/refs'
import smoothScroll from '../helpers/smoothScroll'
import site from '../helpers/site'

class CPdpSubnav {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()
    this.init()
  }

  init () {
    this.$refs.items.forEach((item) => {
      // Hide links who have anchors to sections that are not in page
      const anchorID = item.getAttribute('href').slice(1)

      if (document.getElementById(anchorID) !== null) {
        // Show anchor link except for MB support, which has its own logic
        if (anchorID === 'support') {
          // do nothing
        } else {
          item.classList.remove('hidden')
        }

        // For now, ignore scrolling for #features - we have a special offset anchor for that one
        // works on KJ but not MB
        if (this.site === 'kamadojoe') {
          if (anchorID !== 'features') {
            // Event handler
            item.addEventListener('click', (e) => {
              e.preventDefault()
              const element = document.querySelector(item.getAttribute('href'))
              if (element) {
                smoothScroll(element, true, -208)
              }
            })
          }
        } else {
          // do for all on MB - was like this before KJ and the site was mostly working (code was not in custom.js yet)
          // "See full description" scrolls too far (not adjusted for header) and is in site custom.js
          // Event handler
          item.addEventListener('click', (e) => {
            e.preventDefault()
            const element = document.querySelector(item.getAttribute('href'))
            if (element) {
              smoothScroll(element, true, -208)
            }
          })
        }

        const focusElement = () => {
          const element = document.querySelector(item.getAttribute('href'))

          if (element) {
            element.focus()
          }
        }

        // On link click, set focus to the anchor element
        item.addEventListener('click', focusElement)

        // On keyboard "ENTER", set focus to the anchor element
        item.addEventListener('keyup', (e) => {
          if (e.keyCode === 13) {
            focusElement()
          }
        })
      }
    })

    if (this.$refs.openOverlay) {
      this.$refs.openOverlay.addEventListener('click', () => {
        const overlay = document.getElementById('c-out-of-stock__overlay')
        overlay.classList.replace('hidden', 'flex')
      })
    }

    if (this.component.querySelector('.a-button')) {
      this.component.querySelector('.a-button').addEventListener('click', (e) => {
        const event = new CustomEvent('masterbuilt:open-cart-menu')
        document.dispatchEvent(event)
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-pdp-subnav]')
    .forEach(el => new CPdpSubnav(el))
})
